export const BFI_USER_UPDATE = 'BFI_USER_UPDATE';
export const LOAD_BFI_USER = 'LOAD_BFI_USER';

export const bfiUserUpdate = (state, loginDT) => (dispatch) => {
    const bfiUserObject = { value: JSON.stringify(state), timestamp: loginDT };
    window.localStorage.setItem('bfiUser', JSON.stringify(bfiUserObject));
    dispatch({ type: BFI_USER_UPDATE, state });
};

export const loadBfiUser = () => (dispatch) => {
    const bfiUserObject = window.localStorage.getItem('bfiUser');
    const bfiUserValue = JSON.parse(bfiUserObject);
    const state = JSON.parse(bfiUserValue.value);
    dispatch({ type: LOAD_BFI_USER, state });
};

export default { BFI_USER_UPDATE, bfiUserUpdate, LOAD_BFI_USER, loadBfiUser };
